<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 34.25 34.28">
    <g id="Camada_1-2" data-name="Camada_1">
      <path
        d="M3.67,20.36c-.31-.03-.55-.06-.79-.08-1.29-.15-2.21-.83-2.66-2.04-.47-1.24-.19-2.38.73-3.33,1.02-1.06,2.08-2.09,3.12-3.13,3.52-3.52,7.03-7.03,10.55-10.55,1.66-1.66,3.4-1.65,5.07.01,4.51,4.51,9.02,9.01,13.52,13.53,1.81,1.81,1.18,4.67-1.17,5.37-.42.13-.87.15-1.43.23,0,.23,0,.48,0,.74,0,2.99,0,5.98,0,8.96,0,2.74-1.47,4.19-4.22,4.19-1.56,0-3.12,0-4.68,0-.91,0-1.25-.34-1.26-1.25,0-2.48,0-4.95,0-7.43,0-1.47-.6-2.06-2.07-2.06-.85,0-1.69,0-2.54,0-1.37,0-1.99.62-1.99,2.01,0,2.41,0,4.82,0,7.22,0,1.23-.26,1.5-1.48,1.5-1.56,0-3.12,0-4.68,0-2.46,0-4-1.53-4-4.01,0-3.03,0-6.07,0-9.1,0-.26,0-.52,0-.81Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HomeIcon'
}
</script>
